<!-- 

Note that this isn't really a "default" template
by normal means, this is a default for the POLLS
which means that it has an overlay, 

-->
<template>
  <div id="focus-trap" class=" fixed z-a1 bg-black-80 inset-0 overflow-auto scrolling-touch">
    <div class="global-container-xl global-padding py-20 min-h-screenh">
      <!-- Beginning of card -->
      <div id="card-container" class="p-6 md:p-8 card max-w-6xl w-full m-auto relative">
        <div
          v-if="loading"
          class="absolute bg-white-80 inset-0 z-1 text-black flex items-center justify-center p-8"
        >
          <div class="text-center">
            <svg-icon icon="tail-spin" class="text-black" size="8" />
            <div class="uppercase font-bold text-12 tracking-serif">Loading</div>
          </div>
        </div>

        <!-- NAV BAR -->
        <portal-target name="navbar" class="mb-4 md:mb-12">
          <div class="h-4 mb-4">
            <router-link
              v-if="nextUrl"
              class="inline-block antialiased text-16 text-lightgrey-d font-bold"
              :to="nextUrl"
            >Skip</router-link>
          </div>

          <!-- 
              <ProgressBar class="my-2" :question="step" :total="totalQuestions" :progress="progress" />
          -->

          <div
            class="text-14 font-light opacity-85 text-theme-fg"
          >Question {{ $route.params.step }} / {{ questions.length }}</div>

          <div class="flex rounded-lg overflow-hidden pt-1 pb-2">
            <router-link
              v-for="question in questions"
              class="inline-block relative flex-grow flex-shrink px-2 leading-none leading-medium py-1 text-12 rounded-lg mx-px text-white block m-0 hover:opacity-100 tab-link"
              :class="{
                  ' bg-blue bg-theme-highlight opacity-70': $route.params.step > question.i,
                  ' bg-blue bg-theme-highlight': $route.params.step === question.i,
                  'bg-black-20 hover:bg-black-60': $route.params.step < question.i,
                }"
              :aria-label="`Go to ${ question.i }`"
              :to="`/${slug}/${question.i}/`"
              :key="`question-${question.i}`"
            >
              <div class="inset-0 absolute -my-2"></div>
              <!-- <span class="opacity-50 text-10 inline-block align-middle mr-2">{{ question.type }}</span> -->
              <!--  -->
            </router-link>
          </div>
        </portal-target>

        <!-- MAIN DEFAULT SLOT -->
        <!-- This is basically where the vue route goes...hidden if 'loading' -->
        <div
          :class="{
            //  'opacity-0 pointer-events-none': loading
            }"
          class="relative z-0"
        >
          <slot />
        </div>

        <router-link class="z-5 absolute right-0 top-0 text-black m-4" to="/" aria-label="Close">
          <svg-icon icon="close" size="4" />
        </router-link>
      </div>

      <!-- <portal-target
          class="relative z-2 mt-8 card w-full max-w-4xl mx-auto p-4"
          name="debug"
          multiple
      />-->

      <!-- End of card -->
    </div>

    <store-error />
  </div>
</template>

<script>
import StoreError from "@/vue/components/StoreError.vue";
import { mapState } from 'vuex'
export default {
  components: {
    StoreError,
  },

  computed: {
    user() {
      return this.$store.state.user
    },
    ...mapState('polls', [
      'title',
      'slug',
      'id',
      'questions',
    ]),

    ...mapState({
      loading: state => state.polls.loading
    }),

    nextStep() {
      const i = parseInt(this.$route.params.step) + 1;
      if (i - 1 === this.questions.length) {
        return false
      }

      return i
    },

    // Not gonna be needed but w/e it's useful for debuggin
    prevUrl() {
      if (parseInt(this.$route.params.step) === 1) return false;
      return `/${this.$route.params.poll}/${parseInt(this.$route.params.step) - 1}`
    },

    nextUrl() {
      if (!this.nextStep) return false;
      return `/${this.$route.params.poll}/${this.nextStep}`
    }
  },

  
}
</script>

<style>
.fix-body {
  overflow: hidden;
  height: 100%;
}

#focus-trap {
  opacity: 0;
  transition: opacity .3s ease;
}

.fix-body #focus-trap {
  opacity: 1;
  transition: opacity .3s ease .3s;
}
</style>

<style scoped>
.router-link {
  @apply border-2 border-transparent bg-black-10 px-2 m-1;
}
.router-link.router-link-active {
  @apply border-2 border-skyblue;
}
.router-link.router-link-exact-active {
  @apply font-bold text-skyblue;
}

.tab-link {
  transition: opacity 0.3s ease, background-color 0.3s ease;
}
</style>